<template>
  <label class="app-checkbox-label">
    <slot />
  </label>
</template>

<script>
export default {
  name: "AppCheckboxLabel"
};
</script>

<style lang="scss">
.app-checkbox-label {
  padding-left: 30px;
  position: relative;
  cursor: pointer;
  .app-checkbox {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
